export const HAS_FREE_USE = 'HAS_FREE_USE';
export const IS_PRO = 'IS_PRO';
export const NO_FREE_USE = 'NO_FREE_USE';
